import { PageViewEventLogger } from '@repo/tracking-service';
import { ReactElement } from 'react';

import { IsFirstLocationContainer } from '@/components/survey/business/first-location/IsFirstLocationContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { LocationProvider } from '@/components/survey/common/LocationProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';

function IsFirstLocationPage() {
  const eventAttributes = useSurveyUserEventAttributes();

  return (
    <PageViewEventLogger pageName={'survey_relocation'} eventProperty={eventAttributes}>
      <IsFirstLocationContainer />
    </PageViewEventLogger>
  );
}

IsFirstLocationPage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>
      <LocationProvider>{page}</LocationProvider>
    </BusinessProvider>
  </SurveyProvider>
);

export default IsFirstLocationPage;
